mutation UpdateInboxEnrollmentForm($input: EnrollmentFormUpdateInput!) {
    inboxEnrollmentFormUpdate(input: $input) {
        enrollmentFormField {
            value
            name
            error
        }
    }
}
